import angular from 'angular';

// Component
import pageComponent from './recapResponsePage.component';

// Dependencies
import '../recapResponseForm';
import '../recapResponseFieldInstance';
import confirmModal from '../modals/confirmModal';
import translateModuleName from '../../translation';

let module = angular.module('recaps.components.recapResponsePage', [
  'recaps.components.recapResponseForm',
  'recaps.components.recapResponseFieldInstance',
  confirmModal.name,
  translateModuleName,
]);

module.component('recapResponsePage', pageComponent);

export default module;
